/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  IconButton
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import useStyles from './useStyles';
import Header from './Header';
// import Footer from './Footer';
import StandardSms from './StandardSms';
import CustomSms from './CustomSms';

const messages = [
  "Your [order type] order at [location] is now ready[slotName]. Thank you.",
  "Your order from [location] is now on its way to [address].",
  "Your order at [location] for [pickup time] is waiting for you. Please contact the store at [phone] if you need assistance.",
  "Your contactless delivery has left [location] and should be there shortly.  Our driver will ring the doorbell at your address.",
  "Thank you for checking in! A Team Member will be out with your order shortly. Stay in your vehicle and call us if you haven't gotten your food in the next 5 minutes.",
  "Thank you for checking in! Your order is not quite ready yet, but a Team Member should be out to you shortly with an update.",
  "Can you please contact [location] about your order at [phone] ? Thank you.",
  "We have a question about your order at [location]. Please contact the store at [phone] as soon as you can.",
  "Your order at [location] is taking longer than expected. We apologize for the delay, please contact the store if you want to change your order.",
  "One of the items on your order from [location] is currently unavailable. Please contact the store at [phone] to select a different item. Thank you.",
  "We are having trouble locating [address]. Please contact the store as soon as possible at [phone] so we can deliver your order.",
];

const Sms = ({
  open,
  onClose,
  selectedItem,
  onHandleSend,
  isCustomSmsType,
  customSmsList,
  onChangeSmsType,
}) => {
  const classes = useStyles();
  const storeInfo = useSelector(state => state.storeInfo);
  const currencyInfo = useSelector(state => state.currencyInfo);
  const { iso2, currency } = currencyInfo || {};

  const smsList = isCustomSmsType ? Array.isArray(customSmsList) ? customSmsList : [] : messages;
  const SmsRowComponent = isCustomSmsType ? CustomSms : StandardSms;

  return (
    <Dialog
      open={open}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      PaperProps={{
        style: {
          minHeight: '60%',
          minWidth: '70%',
        }
      }}
    >
      <DialogTitle id="dialog-title" className={classes.dialogTitleContainer} disableTypography>
        <Typography variant="body1" className={classes.dialogTitle}>{'Sms'}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Header
          onChangeSmsType={onChangeSmsType}
          isCustomSmsType={isCustomSmsType}
        />
        <Box height={'70vh'} overflow={'scroll'}>
          {Array.isArray(smsList) &&
            smsList.map((message, messageIndex) => {
              return (
                <SmsRowComponent
                  key={messageIndex}
                  sms={message}
                  storeInfo={storeInfo?.data || {}}
                  onHandleSend={onHandleSend}
                  selectedItem={selectedItem}
                  iso2={iso2}
                  currency={currency}
                  smsIndex={messageIndex}
                />
              );
            })}
        </Box>
        {/* <Footer
          onClose={onClose}
          onSend={onHandleSend}
        /> */}
      </DialogContent>
    </Dialog>
  );
};

export default Sms;
